import qs from 'qs'
import Vue from 'vue'

import { api } from '@/services'
import { cleanObject, generateExcelLink } from '@/util/helpers'

// movements service needs to be refactored --------------------------------------------
function createReport(params) {
  return api.get(`web/movement/createReport?${params}`, { responseType: 'arraybuffer' })
}

function createReportByBranch(params) {
  return api.get(`web/movement/createReportGroupedByBranch?${params}`, { responseType: 'arraybuffer' })
}

function createAdminReport(params) {
  return api.get(`admin/movement/createReport?${params}`, { responseType: 'arraybuffer' })
}

function createAdminReportByBranch(params) {
  return api.get(`admin/movement/createReportGroupedByBranch?${params}`, { responseType: 'arraybuffer' })
}
// -------------------------------------------------------------------------------------

const state = {
  movement: {},
  movements: [],
  isGeneratingReportGroupedByBranch: false,
}

const getters = {
  movement: (state) => state.movement,
  movements: (state) => state.movements,
  isGeneratingReportGroupedByBranch: (state) => state.isGeneratingReportGroupedByBranch,
}

const actions = {
  async fetchMovements({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await api.get('/web/movement', { params })
      const { result, total } = await data

      commit('setMovements', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchMovementsAsAdmin({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await api.get('/admin/movement/list', { params })
      const { result, total } = await data

      commit('setMovements', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchMovement({ commit }, id) {
    commit('setMovement', {})

    try {
      const { data } = await api.get(`/web/movement/${id}`)
      commit('setMovement', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    }
  },

  async fetchMovementAsAdmin({ commit }, id) {
    commit('setMovement', {})

    try {
      const { data } = await api.get(`/admin/movement/show/${id}`)
      commit('setMovement', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    }
  },

  async fetchMovementReport({ commit, dispatch, rootState }) {
    commit('setIsGeneratingReport', true)

    const params = rootState.filters.filters
    const parsedParams = qs.stringify(cleanObject(params), { arrayFormat: 'repeat' })

    try {
      const response = await createReport(parsedParams)
      generateExcelLink(response, Vue.i18n.translate('movement.label.movementReport'))
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsGeneratingReport', false)
    }
  },

  async fetchAdminMovementReport({ commit, dispatch, rootState }) {
    commit('setIsGeneratingReport', true)

    const params = rootState.filters.filters
    const parsedParams = qs.stringify(cleanObject(params), { arrayFormat: 'repeat' })

    try {
      const response = await createAdminReport(parsedParams)
      generateExcelLink(response, Vue.i18n.translate('movement.label.movementReport'))
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsGeneratingReport', false)
    }
  },

  async fetchAdminMovementReportGroupedByBranch({ commit, dispatch, rootState }) {
    commit('setIsGeneratingReportGroupedByBranch', true)

    const params = rootState.filters.filters
    const parsedParams = qs.stringify(cleanObject(params), { arrayFormat: 'repeat' })

    try {
      const response = await createAdminReportByBranch(parsedParams)
      generateExcelLink(response, Vue.i18n.translate('movement.label.movementReportByBranch'))
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsGeneratingReportGroupedByBranch', false)
    }
  },

  async fetchMovementReportGroupedByBranch({ commit, dispatch, rootState }) {
    commit('setIsGeneratingReport', true)

    const params = rootState.filters.filters
    const parsedParams = qs.stringify(cleanObject(params), { arrayFormat: 'repeat' })

    try {
      const response = await createReportByBranch(parsedParams)
      generateExcelLink(response, Vue.i18n.translate('movement.label.movementReportByBranch'))
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsGeneratingReport', false)
    }
  },

  async addBalance(state, body) {
    return await api.post("/admin/movement/addBalance", body)
  }
}

const mutations = {
  setMovement: (state, movement) => {
    state.movement = movement
  },

  setMovements: (state, movements) => {
    state.movements = movements
  },

  setIsGeneratingReportGroupedByBranch: (state, status) => {
    state.isGeneratingReportGroupedByBranch = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
